import Navigation from "./Navigation/Navigation";
import "./App.css";


function App() {

  return (
    <>
      <Navigation />
    </>
  );
}

export default App;
